module.exports = __webpack_public_path__ + "img/tubalu.5a8ceee0.svg";